import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-internalerror',
  templateUrl: './internalerror.component.html',
  styleUrls: ['./internalerror.component.css']
})
export class InternalerrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
